import React from "react";

const NoServiceFound = () => {
  return (
    <svg width="348" height="231" viewBox="0 0 348 231" fill="none">
      <rect
        x="0.09375"
        width="338"
        height="217"
        rx="30"
        fill="url(#paint0_linear_4025_23795)"
      />
      <path
        d="M254.261 171.169L245.162 178.062L236.945 179.048L240.889 195.809L268.496 196.467L287.887 171.16C301.296 166.428 299.828 161.081 297.418 159L285.437 164.53C284.882 164.786 284.295 164.968 283.693 165.072L258.166 169.473C256.748 169.718 255.408 170.299 254.261 171.169Z"
        fill="black"
      />
      <path
        d="M317.877 173.485L286.548 196.439C285.365 197.306 283.861 197.609 282.434 197.27L277.781 196.162L278.439 193.205L305.31 174.246C311.922 169.451 315.977 171.705 317.877 173.485Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M317.77 173.558L317.874 173.482C315.974 171.702 311.919 169.448 305.307 174.244L288.134 186.36L280.656 193.317L309.577 173.789C309.577 173.789 313.618 170.991 317.77 173.558Z"
        fill="black"
      />
      <path
        d="M276.302 197.792L270.41 197.566L290.394 174.032C295.365 167.551 301.266 168.259 303.595 169.423L280.256 196.089C279.263 197.224 277.809 197.85 276.302 197.792Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M303.189 169.243C300.634 168.206 295.096 167.899 290.391 174.033L271.652 196.102L271.783 196.469L294.132 173.134C294.132 173.134 298.679 168.098 303.189 169.243Z"
        fill="black"
      />
      <path
        d="M266.453 201.629L260.191 201.406L278.029 177.405C282.499 170.569 288.108 170.502 290.518 171.488L270.716 199.518C269.742 200.896 268.139 201.69 266.453 201.629Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M290.105 171.34C287.512 170.528 282.259 170.933 278.028 177.405L267.055 192.169L267.51 192.194L281.643 175.104C281.643 175.104 285.882 171.326 290.105 171.34Z"
        fill="black"
      />
      <path
        d="M264.336 198.692L278.027 174.447C273.032 171.292 268.934 175.762 267.51 178.391L259.806 190.718C259.521 191.175 258.924 191.323 258.457 191.053L240.561 180.692C234.25 175.959 226.428 182.335 223.142 188.908L203.094 230.319H231.687L240.895 204.475C241.479 202.837 243.054 201.764 244.792 201.82L258.015 202.246C260.62 202.33 263.055 200.961 264.336 198.692Z"
        fill="white"
      />
      <path
        d="M49.2934 79.5279C46.9907 198.396 33.805 206.871 27.5 217.166H184.166C175.942 178.1 174.434 123.074 174.709 79.5279C176.216 57.6853 166.156 14 113.851 14C61.5471 14 49.0193 57.6853 49.2934 79.5279Z"
        fill="black"
      />
      <path
        d="M87.5547 159.831H140.054L143.336 217.164H83.3359L87.5547 159.831Z"
        fill="white"
      />
      <path
        d="M153.334 192.331C98.6679 192.331 78.6124 161.498 75.418 146.082L153.334 142.332V192.331Z"
        fill="black"
      />
      <path
        d="M170.897 90.7824C173.993 126.174 153.883 172.416 122.018 175.203C90.1534 177.991 58.6012 136.269 55.5049 100.878C52.4085 65.4866 75.7298 34.5363 107.595 31.7485C139.459 28.9607 167.801 55.3911 170.897 90.7824Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.809 152.193C111.961 151.766 112.414 151.555 112.822 151.721C116.361 153.161 121.141 152.489 124.146 150.13C124.492 149.858 124.986 149.936 125.25 150.305C125.513 150.673 125.446 151.192 125.1 151.464C121.665 154.161 116.318 154.912 112.272 153.266C111.865 153.1 111.657 152.619 111.809 152.193Z"
        fill="black"
      />
      <path
        d="M132.007 142.772C133.423 142.609 135.008 141.659 135.605 141.592C136.005 141.548 136.171 142.006 135.856 142.211C135.825 142.232 135.793 142.251 135.764 142.275C130.739 146.34 122.761 147.592 118.305 148.218L117.622 143.362C117.622 143.362 118.29 143.311 118.848 142.898C119.406 142.485 119.989 141.929 120.953 142.095C126.313 143.018 124.588 143.631 132.007 142.772Z"
        fill="black"
      />
      <path
        d="M102.78 148.001C101.618 148.312 100.881 148.467 100.288 148.568C99.8724 148.638 99.8551 149.169 100.272 149.245C106.278 150.349 113.834 148.846 118.303 148.218L117.621 143.362C117.621 143.362 116.965 143.497 116.315 143.254C115.665 143.011 114.951 142.637 114.07 143.062C109.172 145.427 110 146.064 102.78 148.001Z"
        fill="black"
      />
      <path
        d="M163.279 93.0979C159.465 114.724 158.65 111.198 168.271 112.895C174.433 113.981 183.66 107.983 185.591 97.0321C187.522 86.0809 181 81.4127 174.839 80.3263C161.416 77.9595 166.06 77.3256 163.279 93.0979Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M182.895 91.7027C182.313 88.2631 180.26 85.6205 177.326 84.6884C176.887 84.549 176.418 84.7917 176.279 85.2303C176.14 85.6689 176.382 86.1375 176.821 86.2768C179.049 86.9846 180.753 89.0324 181.252 91.981C181.751 94.9282 181.03 98.761 178.354 102.837C178.101 103.222 178.208 103.739 178.593 103.991C178.978 104.244 179.495 104.137 179.747 103.752C182.606 99.3969 183.478 95.1437 182.895 91.7027Z"
        fill="black"
      />
      <path
        d="M62.9454 101.876C70.4563 122.511 70.6466 118.897 61.4664 122.239C55.5874 124.379 45.4592 120.074 41.6558 109.624C37.8525 99.1749 43.4645 93.4452 49.3435 91.3054C62.1515 86.6437 57.4676 86.8259 62.9454 101.876Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.3804 103.908C43.3567 100.42 44.9192 97.4611 47.6473 96.0335C48.0551 95.8201 48.5587 95.9777 48.772 96.3855C48.9854 96.7932 48.8278 97.2968 48.4201 97.5102C46.3487 98.5941 45.0267 100.907 45.047 103.897C45.0673 106.886 46.4429 110.536 49.7861 114.085C50.1016 114.42 50.0858 114.948 49.7508 115.263C49.4158 115.579 48.8884 115.563 48.5728 115.228C45.0011 111.436 43.4041 107.398 43.3804 103.908Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.999 100.199C114.687 100.139 115.293 100.648 115.353 101.336L117.387 124.58C117.447 125.268 116.938 125.874 116.251 125.934C115.563 125.995 114.957 125.486 114.896 124.798L112.863 101.554C112.803 100.866 113.311 100.26 113.999 100.199Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.006 127.861C108.45 127.333 109.238 127.264 109.767 127.707L113.378 130.738C113.907 131.181 113.976 131.97 113.532 132.499C113.089 133.027 112.3 133.096 111.771 132.653L108.16 129.623C107.631 129.179 107.562 128.39 108.006 127.861Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.71 126.4C124.181 125.956 123.393 126.025 122.949 126.554L119.919 130.165C119.475 130.694 119.544 131.483 120.073 131.926C120.602 132.37 121.39 132.301 121.834 131.772L124.864 128.161C125.308 127.632 125.239 126.844 124.71 126.4Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.6053 97.5347L69.1127 96.3924C68.5053 96.1225 67.7929 96.3753 67.4913 96.9676C67.1897 97.56 67.4045 98.2847 67.9801 98.6172L71.596 100.706C73.0483 101.716 74.5919 103.035 75.6456 104.581C76.0345 105.151 76.8122 105.298 77.3826 104.909C77.953 104.52 78.1001 103.743 77.7112 103.172C77.0071 102.14 76.1469 101.216 75.2514 100.41C78.2596 97.3674 82.4297 94.9265 86.9326 94.7374C91.7342 94.5359 97.2451 96.8848 102.425 104.581C102.811 105.154 103.588 105.305 104.16 104.92C104.733 104.534 104.885 103.758 104.499 103.185C98.9641 94.9615 92.7081 91.9928 86.8277 92.2397C81.4337 92.4661 76.6407 95.3902 73.3166 98.8123L72.9358 98.5924C72.723 98.4456 72.5143 98.3064 72.3116 98.1748C71.4317 97.6037 70.6404 97.162 70.067 96.8621C69.7799 96.712 69.5462 96.5967 69.3821 96.518C69.3 96.4786 69.2352 96.4484 69.1896 96.4274L69.136 96.4028L69.1205 96.3958L69.1156 96.3937L69.1139 96.3929C69.1136 96.3928 69.1127 96.3924 68.6053 97.5347Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.6491 94.4538C86.304 95.264 86.1809 96.3411 86.3563 97.7855C86.9268 102.482 89.9134 105.983 93.0269 105.605C95.7302 105.277 97.6168 102.408 97.6937 98.5842C93.9736 95.2269 90.0597 94.2364 86.6491 94.4538Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.0354 88.9621C66.8433 87.5948 67.7959 86.3307 69.1632 86.1385L100.522 81.7314C101.889 81.5392 103.153 82.4918 103.345 83.8591C103.537 85.2264 102.585 86.4906 101.217 86.6827L69.859 91.0898C68.4918 91.282 67.2276 90.3294 67.0354 88.9621Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.259 89.6912L157.561 88.6543C158.112 88.2831 158.858 88.4083 159.258 88.9392C159.657 89.4702 159.572 90.2213 159.063 90.6486L155.864 93.3332C154.61 94.5808 153.319 96.1478 152.549 97.8527C152.265 98.482 151.525 98.7619 150.896 98.4779C150.266 98.194 149.986 97.4537 150.27 96.8244C150.784 95.6853 151.471 94.6261 152.213 93.6764C148.722 91.2028 144.192 89.5231 139.724 90.1189C134.961 90.7542 129.941 94.0244 126.176 102.503C125.896 103.134 125.157 103.418 124.527 103.138C123.896 102.858 123.611 102.119 123.891 101.489C127.915 92.4288 133.56 88.4188 139.394 87.6408C144.745 86.9272 149.973 88.9746 153.841 91.7675L154.178 91.4847C154.362 91.3032 154.543 91.1299 154.72 90.9651C155.487 90.2499 156.19 89.6775 156.703 89.2826C156.959 89.0849 157.169 88.9308 157.317 88.8248C157.391 88.7718 157.45 88.7307 157.491 88.7021L157.54 88.6686L157.554 88.659L157.558 88.6561L157.56 88.655C157.56 88.6548 157.561 88.6543 158.259 89.6912Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.385 88.1032C148.389 88.7875 149.058 90.045 149.179 92.2876C149.432 97.0119 147.099 100.979 143.967 101.147C140.835 101.315 138.185 97.9767 137.932 93.2525C137.86 91.9173 137.992 90.8811 138.289 90.0777C141.823 89.2443 145.209 89.9103 147.506 90.9936L147.385 88.1032Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.659 82.2563C121.707 83.6362 122.865 84.7157 124.245 84.6675L155.892 83.5624C157.272 83.5142 158.351 82.3565 158.303 80.9766C158.255 79.5968 157.097 78.5172 155.717 78.5654L124.07 79.6706C122.69 79.7188 121.611 80.8764 121.659 82.2563Z"
        fill="black"
      />
      <path
        d="M67.5027 77.4164L57.0449 78.3314C56.4293 92.8402 62.4384 131.732 64.6124 147.602C59.7718 133.571 52.2798 102.255 51.263 90.6327L53.0948 73.3239L71.8307 43.6615L95.7187 29.8604L137.138 30.001L163.303 53.9777L169.499 65.2312L172.736 78.3322C173.27 98.78 174.216 132.826 172.903 146.493L164.611 68.9206L146.683 70.4891C142.993 69.6073 131.974 57.2206 126.925 51.1375C127.343 55.9192 135.291 66.4666 139.213 71.1426L125.767 72.3189L114.133 59.7853L122.78 72.5803L109.334 73.7567L95.6825 55.3766C96.6238 66.1355 102.275 73.3705 104.983 75.6431C99.9928 73.6705 94.973 64.473 93.0868 60.1209L85.4303 75.848L73.4786 76.8936C72.7465 68.5256 75.0284 60.195 76.2609 57.0758L67.5027 77.4164Z"
        fill="black"
      />
      <rect
        x="225.094"
        y="101.837"
        width="50"
        height="50"
        rx="10"
        transform="rotate(-10.3028 225.094 101.837)"
        fill="#F9F9F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M243.695 115.23L254.254 122.447L261.597 111.975L264.61 128.546L260.763 129.245L259.424 121.88L255.237 127.852L249.215 123.736L250.554 131.101L246.708 131.8L243.695 115.23Z"
        fill="#6C65D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M241.378 134.45L237.801 114.773L241.648 114.073L245.225 133.751L241.378 134.45Z"
        fill="#6C65D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M266.679 129.851L263.102 110.174L266.948 109.475L270.525 129.152L266.679 129.851Z"
        fill="#6C65D9"
      />
      <rect
        x="298.109"
        y="79.8942"
        width="50"
        height="50"
        rx="10"
        transform="rotate(5.21242 298.109 79.8942)"
        fill="#1B1D28"
      />
      <path
        d="M334.027 98.2373L334.029 98.2355L334.031 98.2357L334.031 98.2336"
        fill="#2E3192"
      />
      <path
        d="M322.932 117.304L308.541 115.991C307.625 115.898 306.787 115.579 306.071 115.1C304.523 114.06 303.555 112.257 303.664 110.279L318.614 111.643C318.583 112.318 318.676 112.974 318.875 113.586C319.155 114.445 319.641 115.218 320.281 115.839C320.662 116.207 321.093 116.52 321.569 116.769C321.999 116.992 322.444 117.2 322.932 117.304Z"
        fill="#6C65D9"
      />
      <path
        d="M338.107 100.515L332.975 100.047L331.134 103.211L318.539 102.062C317.499 101.967 316.541 102.443 315.971 103.231C315.864 103.377 315.772 103.537 315.694 103.707C315.562 103.993 315.475 104.306 315.444 104.636C315.414 104.966 315.444 105.293 315.522 105.598C315.561 105.748 315.61 105.89 315.669 106.029C315.87 106.489 316.185 106.888 316.587 107.183C316.992 107.484 317.482 107.678 318.019 107.727L320.999 107.999C321.12 108.01 321.235 108.042 321.336 108.092C321.542 108.192 321.704 108.359 321.797 108.563C321.868 108.713 321.899 108.881 321.883 109.057C321.878 109.115 321.866 109.173 321.851 109.231C321.742 109.579 321.668 109.945 321.633 110.325C321.589 110.812 321.614 111.288 321.697 111.743C322.376 111.563 322.965 111.14 323.351 110.566L323.351 110.563C323.416 110.466 323.475 110.365 323.528 110.258L323.562 110.19C323.701 109.898 323.79 109.573 323.821 109.233C323.852 108.894 323.823 108.558 323.74 108.246C323.628 107.828 323.421 107.439 323.143 107.115C323.081 107.041 323.013 106.972 322.944 106.904C322.933 106.89 322.918 106.88 322.907 106.869C322.881 106.845 322.852 106.821 322.823 106.796C322.815 106.789 322.803 106.779 322.794 106.772C322.728 106.713 322.658 106.663 322.582 106.613C322.447 106.519 322.305 106.438 322.153 106.368C321.857 106.232 321.536 106.144 321.193 106.113L318.185 105.838C317.663 105.791 317.279 105.329 317.327 104.808C317.374 104.286 317.822 103.913 318.335 103.948L330.073 105.019L329.678 105.695L329.332 106.292L329.118 106.658L329.018 106.826L328.782 107.231L328.196 108.239L327.967 108.631L326.882 110.493L325.831 112.298L324.912 113.875L324.451 114.67L324.123 115.234L323.647 116.047L323.547 116.221C323.408 116.149 323.272 116.071 323.139 115.988C322.579 115.644 322.087 115.21 321.669 114.715C321.52 114.537 321.381 114.35 321.253 114.157C320.788 113.452 320.466 112.651 320.326 111.796C320.287 111.447 320.282 111.091 320.315 110.73C320.34 110.45 320.387 110.171 320.458 109.904L309.665 108.919L310.75 107.058L311.535 105.708L311.801 105.253L312.853 103.445L313.904 101.636L314.941 99.858C314.945 99.849 314.952 99.8372 314.959 99.8285L315.129 99.536L315.14 99.5183C315.379 99.145 315.659 98.8004 315.98 98.4967C316.934 97.585 318.248 96.9644 319.638 96.9295L334.474 98.2828C334.612 98.3017 334.744 98.3292 334.875 98.3598C335.963 98.6054 336.916 99.1776 337.641 99.9532C337.812 100.127 337.966 100.316 338.107 100.515Z"
        fill="#A09AFB"
      />
      <path
        d="M338.103 100.515L332.972 100.047C333.373 99.2656 334.057 98.6621 334.878 98.3575C335.966 98.603 336.919 99.1752 337.645 99.9508C337.812 100.131 337.966 100.319 338.103 100.515Z"
        fill="#6C65D9"
      />
      <rect
        x="237.086"
        y="27.8875"
        width="50"
        height="50"
        rx="10"
        fill="black"
      />
      <path
        d="M252.484 40.8875H271.684V64.8874H252.484V40.8875Z"
        fill="url(#pattern0_4025_23795)"
      />
      <defs>
        <pattern
          id="pattern0_4025_23795"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="scale(0.0106383 0.00819672)" />
        </pattern>
        <linearGradient
          id="paint0_linear_4025_23795"
          x1="183.177"
          y1="4.18071e-07"
          x2="185.738"
          y2="207.069"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BFFFB7" />
          <stop offset="0.315" stopColor="#63B4FF" />
          <stop offset="0.64" stopColor="#564ECA" />
          <stop offset="1" stopColor="#232058" />
        </linearGradient>
        <image id="image0_4025_23795" width="286" height="122" />
      </defs>
    </svg>
  );
};

export default NoServiceFound;
